import { render } from "./App.vue?vue&type=template&id=b495c4f4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b495c4f4&lang=scss"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__